import styled from '@emotion/styled';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';

import { PrimaryButton } from '@/components/button';
import { H1 } from '@/components/type';
import { BREAKPOINTS, BOX_SHADOW, COLORS, GLOBAL, SPACE, FONT_SIZE, FONT_WEIGHT, LINE_HEIGHT } from '@/constants';
import { IconButton } from '@/components/icon-button';

const StyledCloseButton = styled(IconButton)`
  background: transparent;
  &.MuiButtonBase-root {
    /* not using short-hand margin to retain margin-right set by MUI edge="end" prop */
    display: block;
    position: absolute;
    right: 3rem;

    @media (min-width: ${BREAKPOINTS.SM}px) {
      font-size: ${FONT_SIZE.MEDIUM};
      line-height: ${LINE_HEIGHT.BODY.MEDIUM};
    }

    @media (min-width: ${BREAKPOINTS.LG}px) {
      font-size: ${FONT_SIZE.LARGE};
      line-height: ${
        /* @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'large' does not exist on type '{ X_LARGE: string; LARGE: string; MEDIUM: string; SMALL: string; X_SMALL: string; XX_SMALL: string; }'. Did you mean 'LARGE'? */
        LINE_HEIGHT.BODY.large
      };
    }
  }
`;

const StyledVehicleHeading = styled(Box)`
  display: flex;
  flex-direction: row;
  gap: ${SPACE.X1};
  margin-top: ${SPACE.X1};
`;

const StyledLabel = styled.span`
  font-size: ${FONT_SIZE.MEDIUM};
  font-weight: ${FONT_WEIGHT.LIGHT};
  font-family: ${GLOBAL.BRAND_FONT_FAMILY_SECOND};
  display: block;
  text-transform: uppercase;
  margin-bottom: ${SPACE.X0};
`;

const StyledMakeModel = styled(H1)`
  margin-bottom: ${
    /* @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'hasExtraSpacing' does not exist on type '{ theme?: Theme | undefined; as?: ElementType<any, keyof IntrinsicElements> | undefined; } & ClassAttributes<HTMLHeadingElement> & HTMLAttributes<...> & { ...; } & { ...; }'. */
    (props) => (props.hasExtraSpacing ? SPACE.X3 : `calc(${SPACE.X1} + ${SPACE.X0})`)
  };
`;

const StyledModalContainer = styled(Box)`
  background-color: ${COLORS.WHITE};
  padding: ${SPACE.X2} 0;
  overflow-x: scroll;
  width: 100%;
  height: 100%;
  position: relative;

  @media (min-width: ${BREAKPOINTS.MD}px) {
    box-shadow: ${BOX_SHADOW.DEFAULT};
    height: 80%;
    width: 80%;
    max-width: 1200px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`;

const StyledContainer = styled(Container)`
  &.MuiContainer-root {
    padding: 0 ${SPACE.X2};

    @media (min-width: ${BREAKPOINTS.MD}px) {
      padding: 0 ${SPACE.X3};
    }
  }
`;

const StyledUpdateButton = styled(PrimaryButton)`
  &.MuiButton-root {
    margin: ${SPACE.X2} 0 ${SPACE.X2} 0;
    width: 100%;

    @media (min-width: ${BREAKPOINTS.MD}px) {
      width: auto;
    }
  }
`;

const StyledYearFilter = styled(Box)`
  margin-bottom: 0;
`;

const StyledSaferVariantGrid = styled(Grid)`
  &.MuiGrid-item {
    padding-top: 0;

    @media (min-width: ${BREAKPOINTS.LG}px) {
      padding-top: ${SPACE.X1};
    }
  }
`;

export {
  StyledCloseButton,
  StyledLabel,
  StyledContainer,
  StyledMakeModel,
  StyledModalContainer,
  StyledUpdateButton,
  StyledYearFilter,
  StyledVehicleHeading,
  StyledSaferVariantGrid,
};
